<template>
  <div class="stylesoption" :data-designer-component-id="component_id" v-if="panel_required">
    <div class="form-group mt-3">
      {{ title }}
      <input type="text" v-model="localTarget" id="panel_depth_bespoke" class="form-control">
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
    import Question from "./mixin/Question.vue";

    export default {
        mixins: [
            Question,
        ],
        props: {
            title: {
                default(){
                    return 'Enter Panel Depth';
                }
            },
            component_id: {
                default(){
                    return 'panel_depth_bespoke';
                }
            },
            panelDepth: {
              required: true
            },
        },
        data() {
          return {
            option_list: {
              has_text_option: false,
            },
          }
        },
        computed: {
            thumbURL(){
                return '/images/';
            },
            url(){
                return '/api/options/' + this.fabricator + '/panel-depth-bespoke?panel_depth=' + this.panelDepth;
            },
            cache_key(){
              return '_' + this.panelDepth;
            },
            panel_required() {
              return this.options_loaded && this.option_list.has_text_option;
            }
        },
        watch: {
          'cache_key': function (val, oldVal) {
            this.update_options();
          },
          'localTarget': {
            handler: _.debounce(function () {
              this.localTarget = this.localTarget.replace(/[^0-9]+/g,"");
              if (this.localTarget.length >= 2) {
                this.localTarget = this.localTarget.substring(0, 2);
              }
            }, 50),
          },
        }
    }
</script>
